export enum GaEventAction {
  /* DEVICE MENU ACTIONS */
  MENU_ALL_DEVICES_PAGE_CLICK = 'Menu All Devices Page Click',
  MENU_READINGS_PAGE_CLICK = 'Menu Readings Page Click',
  MENU_NEW_GRAPH_PAGE_CLICK = 'Menu New Graph Page Click',
  MENU_FLOW_GRAPH_PAGE_CLICK = 'Menu Flow Graph Page Click',
  MENU_GRAPH_PAGE_CLICK = 'Menu Graph Page Click',
  MENU_ALARM_CONFIG_PAGE_CLICK = 'Menu Alarm Config Page Click',
  MENU_DEVICE_MAP_PAGE_CLICK = 'Menu Device Map Page Click',
  MENU_STATISTICS_PAGE_CLICK = 'Menu Statistics Page Click',
  MENU_EXPORT_PAGE_CLICK = 'Menu Export Page Click',
  MENU_CUSTOMER_PAGE_CLICK = 'Menu Customer Page Click',
  MENU_CONFIG_PAGE_CLICK = 'Menu Config Page Click',
  MENU_INITIAL_CONFIG_PAGE_CLICK = 'Menu Initial Config Page Click',
  MENU_SENSOR_CONFIG_PAGE_CLICK = 'Menu Sensor Config Page Click',
  MENU_DEVICE_COMMANDS_PAGE_CLICK = 'Menu Device Commands Page Click',
  MENU_DEVICE_COPY_CONFIG_PAGE_CLICK = 'Menu Device Copy Config Page Click',
  MENU_DEVICE_SIGNAL_PAGE_CLICK = 'Menu Device Signal Page Click',
  MENU_DEVICE_BATTERY_PAGE_CLICK = 'Menu Device Battery Page Click',
  MENU_ALARMS_PAGE_CLICK = 'Menu Alarms Page Click',
  MENU_DEVICE_PREDICTION_PAGE_CLICK = 'Menu Device Prediction Page Click',
  MENU_VALUE_RANGE_PAGE_CLICK = 'Menu Value Range Page Click',
  MENU_CUSTOMER_BILLING_REPORT_PAGE_CLICK = 'Menu Customer Billing Report Page Click',
  MENU_SENSORS_AND_NETWORK_CONFIG_PAGE_CLICK = 'Menu Sensors And Network Config Page Click',
  MENU_SENSORS_DATA_PAGE_CLICK = 'Menu Sensors Data Page Click',

  /* DEFAULT MENU ACTIONS */
  MENU_SELECTED_DEVICE_PAGE_CLICK = 'Menu Selected Device Page Click',
  MENU_DEVICES_PAGE_CLICK = 'Menu Devices Page Click',
  MENU_MAP_PAGE_CLICK = 'Menu Map Page Click',
  MENU_TRANSMISSIONS_PAGE_CLICK = 'Menu Transmissions Page Click',
  MENU_INVENTORY_PAGE_CLICK = 'Menu Inventory Page Click',
  MENU_LINK_DEVICE_PAGE_CLICK = 'Menu Link Device Page Click',
  MENU_USERS_PAGE_CLICK = 'Menu Users Page Click',
  MENU_ICON_PAGE_CLICK = 'Menu Icon Page Click',
  MENU_ACCOUNTS_PAGE_CLICK = 'Menu Accounts Page Click',
  MENU_MANAGE_ACCOUNTS_PAGE_CLICK = 'Menu Manage Accounts Page Click',
  MENU_MANAGE_ICONS_PAGE_CLICK = 'Menu Manage Icons Page Click',
  MENU_MANAGE_LICENSES_PAGE_CLICK = 'Menu Licenses Page Click',
  MENU_DEVICES_BATTERY_PAGE_CLICK = 'Menu Devices Battery Page Click',
  MENU_DEVICES_SIGNAL_PAGE_CLICK = 'Menu Devices Signal Page Click',
  MENU_DASHBOARD_PAGE_CLICK = 'Menu Dashboard Page Click',
  MENU_REPORTS_PAGE_CLICK = 'Menu Reports Page Click',
  MENU_SCHEDULED_REPORTS_PAGE_CLICK = 'Menu Scheduled Reports Page Click',
  MENU_ALL_ALARMS_PAGE_CLICK = 'Menu All Alarms Page Click',
  MENU_DEVICE_GROUP_PAGE_CLICK = 'Menu Device Group Page Click',
  MENU_DEVICE_NODES_PAGE_CLICK = 'Menu Device Nodes Page Click',
  MENU_BILLING_REPORT_PAGE_CLICK = 'Menu Billing Report Page Click',
  MENU_UTILITY_RATE_PAGE_CLICK = 'Menu Utility Rate Page Click',

  /* PAGE ACTIONS */
  DEVICES_PAGE_DEVICE_NUMBER_CLICK = 'Devices Page Device Number Click',
  INVENTORY_PAGE_DEVICE_NUMBER_CLICK = 'Inventory Page Device Number Click',
  DEVICES_SIGNAL_PAGE_DEVICE_NUMBER_CLICK = 'Devices Signal Page Device Number Click',
  BATTERY_STATUS_PAGE_DEVICE_NUMBER_CLICK = 'Battery Status Page Device Number Click',
  TRANSMISSIONS_PAGE_APPLY_BUTTON_CLICKED = 'Transmissions Page Apply Button Click',
  LINK_DEVICE_PAGE_LINK_DEVICE = 'Link Device Page Link Device Click',
  LINK_DEVICE_PAGE_UNLINK_DEVICE = 'Link Device Page Unlink Device Click',
  DEVICE_MANAGER_CREATE_DEVICE = 'Device Manager Page Create Device Click',
  DEVICE_MANAGER_DELETE_DEVICE = 'Device Manager Page Delete Device Click',
  LOGIN_CLICK = 'Create User Page Login Click',
  REPORT_PAGE_DOWNLOAD_CLICK = 'Reports Page Download Button Click',
  REPORT_PAGE_SEARCH_CLICK = 'Reports Page Search Button Click',
  ALL_ALARMS_PAGE_DOWNLOAD_CLICK = 'All Alarms Page Download Button Click',
  ALL_ALARMS_PAGE_REFRESH_CLICK = 'All Alarms Page Refresh Button Click',
  READING_PAGE_DOWNLOAD_CLICK = 'Readings Page Download Button Click',
  READING_PAGE_SEARCH_CLICK = 'Readings Page Search Button Click',
  FLOW_PAGE_APPLY = 'Flow Page Apply Button Click',
  GRAPH_PAGE_APPLY = 'Graph Page Apply Button Click',
  ALARM_CONFIG_SAVE = 'Alarm Config Page Save Button Click',
  EXPORT_PAGE_DOWNLOAD_CLICK = 'Export Page Download Button Click',
  EXPORT_PAGE_SEARCH_CLICK = 'Export Page Search Button Click',
  CUSTOMER_PAGE_SAVE = 'Customer Page Save Button Click',
  CONFIG_START_SETUP = 'Config Page Start Setup Click',
  INITIAL_CONFIG_SAVE = 'Initial Config Page Save Button Click',
  SENSOR_CONFIG_SAVE = 'Sensor Config Page Save Button Click',
  ALARMS_PAGE_REFRESH_CLICK = 'Alarms Page Refresh Button Click',
  ALARMS_PAGE_DOWNLOAD_CLICK = 'Alarms Page Download Button Click',

  /* PROFILE PAGE ACTIONS */
  CHANGE_LANGUAGE_SAVE = 'Profile Page Change Language Save Click',
  CHANGE_PASSWORD_SAVE = 'Profile Page Change Password Save Click',
}
